import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslocoPipe } from '@jsverse/transloco';
import { MessengerService, ModalComponent } from '@web/birdz-angular';
import { UserService } from 'app/services/user.service';

@Component({
  selector: 'app-modal-kpi-settings',
  templateUrl: './modal-kpi-settings.component.html',
  styleUrl: './modal-kpi-settings.component.scss',
  imports: [TranslocoPipe, ModalComponent, MatSlideToggleModule, FormsModule, MatButtonModule],
})
export class ModalKpiSettingsComponent {
  private userService = inject(UserService);
  private messenger = inject(MessengerService);
  private dialogRef = inject<MatDialogRef<ModalKpiSettingsComponent>>(MatDialogRef);

  showRawKpis = this.userService.getShowRawKpis();

  save() {
    this.userService
      .patchPreferences({ show_raw_kpis: this.showRawKpis })
      .pipe(this.messenger.showFriendlyErrorMessage())
      .subscribe(() => window.location.reload());
  }

  cancel() {
    this.dialogRef.close();
  }
}
